export enum AddressType {
  HOME = 'casa',
  WORK = 'trabalho',
  OTHER = 'outro',
}

export const AddressTypeLabel: Record<AddressType, string> = {
  [AddressType.HOME]: 'Casa',
  [AddressType.WORK]: 'Trabalho',
  [AddressType.OTHER]: 'Outro',
};

export function parseAddressType(value: string): AddressType {
  const lowerValue = value.toLowerCase().trim();

  if (lowerValue.includes('casa') || lowerValue === AddressType.HOME) {
    return AddressType.HOME;
  }

  if (
    lowerValue.includes('trabalho') ||
    lowerValue.includes('profissional') ||
    lowerValue === AddressType.WORK
  ) {
    return AddressType.WORK;
  }

  return AddressType.OTHER;
}
